import { render, staticRenderFns } from "./EventRaceList.vue?vue&type=template&id=51b9447b&"
import script from "./EventRaceList.vue?vue&type=script&lang=js&"
export * from "./EventRaceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports